const initialState = {
  loading: false,
  referral: localStorage.getItem('referral') || '',
  error: null
}

function referralCodeReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_REFERRAL_CODE_BEGIN':
      return {
        ...state,
        loading: true
      }

    case 'GET_REFERRAL_CODE_SUCCESS':
      return {
        ...state,
        loading: false,
        referral: action.referral
      }

    case 'GET_REFERRAL_CODE_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case 'GET_AUTHENTICATE_FAILURE':
      return {
        ...state,
        referral: ''
      }

    default:
      return state
  }
}

export default referralCodeReducer
